import React, { useMemo } from 'react';

/**
 * Safe JSON-LD <script> renderer.
 *
 * - Memoises the serialised JSON so the prop identity is stable
 *   across renders (no needless DOM churn).
 * - Escapes `<` so a stray closing `</script>` in any string value
 *   can't break out of the script tag. This makes the use of
 *   `dangerouslySetInnerHTML` here genuinely safe even if any of
 *   the data values were ever sourced from user input in the future.
 */
const JsonLd = ({ data }) => {
  const json = useMemo(
    () => JSON.stringify(data).replace(/</g, '\\u003c'),
    [data]
  );
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
};

export default JsonLd;
